module.exports = __webpack_public_path__ + "static/Terminal_DeepOcean.2aba7175118efc7b74affef123d861e2.png";